import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'educare-confirmation-dialog',
  templateUrl: './listing-dialog.component.html',
  styleUrl: './listing-dialog.component.scss',
  imports: [CommonModule, MatDialogActions, MatDialogContent, FormsModule]
})
export class ListingDialogComponent {
  public readonly dialogRef = inject(MatDialogRef<ListingDialogComponent>);
  public readonly data = inject<{ title: string; data: any[] }>(MAT_DIALOG_DATA);

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
